// Felles tekster og hjelpere for dekkhotellet i ansatt-appen (se dekkhotell-plan.md).
export const SETT_LABEL = { sommer: "Sommerdekk", vinter: "Vinterdekk" };
export const FORM_LABEL = { dekk: "Bare dekk", hjul: "Hjul (dekk på felg)" };
export const TILSTAND_LABEL = { god: "God", slitt: "Slitt", "bor-byttes": "Bør byttes" };
export const HENDELSE_LABEL = {
  inn: "Lagt inn",
  bytte: "Dekkskift",
  ut: "Utlevert",
  flyttet: "Flyttet",
};

// Samme liste som LAGERSTEDER i src/model/Dekkhotell.js.
export const LAGERSTED_LABEL = {
  "sport1-royken": "Sport 1 Røyken",
  "sport1-slemmestad": "Sport 1 Slemmestad",
  verksted: "Verkstedet",
  lagerbod: "Lagerboden",
};

// Forslag til lagersted ut fra butikken den ansatte er logget inn i (butikkid-cookien).
export function lagerstedForButikk(butikkid) {
  if (Number(butikkid) === 1) return "sport1-royken";
  if (Number(butikkid) === 2) return "sport1-slemmestad";
  return "";
}

export function stedTekst(post) {
  return [LAGERSTED_LABEL[post?.lagersted], post?.plassering].filter(Boolean).join(", ");
}

export const TOMT_SETT = {
  sett: "sommer",
  form: "dekk",
  antall: 2,
  beskrivelse: "",
  pigger: false,
  tilstand: "god",
  kommentar: "",
};

export function settTekst(s) {
  if (!s) return "";
  const deler = [
    SETT_LABEL[s.sett] || s.sett,
    s.pigger ? "med pigger" : "",
    s.form === "hjul" ? `${s.antall || 2} hjul` : `${s.antall || 2} dekk`,
    s.beskrivelse,
  ];
  return deler.filter(Boolean).join(" · ");
}

export function kundeNavn(k) {
  return [k?.firstName, k?.lastName].filter(Boolean).join(" ");
}

export function settMerkeCls(sett) {
  return sett === "vinter" ? "bg-sky-100 text-sky-800" : "bg-amber-100 text-amber-800";
}

export function fmtDato(d) {
  return d ? new Date(d).toLocaleDateString("nb-NO") : "";
}

// Spørsmålet kunden får når settet legges inn. Samme tekst som
// «dekkhotell-sms-v1» i src/samtykke/tekster.js; endres den, lag en ny versjon der.
export const SESONG_SMS_SPORSMAL =
  "Vil du ha SMS fra oss når det er tid for å bytte dekk, om våren og om høsten? " +
  "Du kan ombestemme deg når som helst.";
